import { ButtonField, debounce, InputField, Pagination, PaginationBar, PaginationBarLeft, PaginationBarRight, SearchSuggestionsWrapper, SelectField } from "@wk/components-react16";
import { useEffect, useRef, useState } from "react";
import { API_URL, API_USER } from "../../config/constants";
import { Toast } from "../../services";
import HttpService from "../../config/http.service";
import moment from "moment";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../store/authReducer";


const UserActivityLog = () => {
    // interface activityLogPayload {
    //     pageNumber: number;
    //     pageSize: number;
    //     searchText?: string;
    //     entityType?: string;
    //     username?: string;
    //     startDate?: string;
    //     endDate?: string;
    // }
    const entityTypeList = [
        {code: 'PROMPT', name: 'Prompt Management' },
        {code: 'DIMENSION', name: 'Dimensions Management' },
        {code: 'TAXONOMY', name: 'Taxonomy Management' },
        {code: 'VALIDATION_RULE', name: 'Validation Management' },
        {code: 'PROJECT', name: 'Project Management' },
    ];
     const suggestionList: any = [
        {
            id: "userlist",
            type: "suggestions",
            title: "User suggestions",
            hasIcon: true,
            suggestions: []
        }
    ]
    const dispatch = useDispatch();
    const searchRef = useRef<SearchSuggestionsWrapper>(null);
    const [currentEntityType, setCurrentEntityType] = useState<any>('');
    const [searchText, setSearchText] = useState('');
    const [searchText2, setSearchText2] = useState('');
    const [suggestionUserList, setSuggestionUserList] = useState(suggestionList);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [projectList, setProjectList] = useState([] as any);
    const [currentProject, setCurrentProject] = useState<any>('');
    const [logData , setLogData] = useState<any>([]);
    const [pagination, setPagination] = useState({ pageIndex: 1, pageSize: 10, pageCount: 0, totalCount: 0 });
    
    const handleInputChange = (event: any) => {
        const { value } = event.target;
        setCurrentEntityType(value);
    }

    // ************************* User suggestion code ************************
    const getSuggestion = (text: string) => {
        setSuggestionUserList([])
        let payload = {
            username: text
        }
        HttpService.postRequest(API_USER.SEARCHUSER, payload).then(
            (res: any) => {
                suggestionList[0].suggestions = res.map((itm: any, index: any) => ({ id: index, text: itm.username, uId: itm.id }));
                setSuggestionUserList(suggestionList);
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    const getSuggestionRef = useRef(getSuggestion);

    useEffect(() => {
        getSuggestionRef.current = getSuggestion;
    }, [getSuggestion]);

    const userSuggestion = useRef(debounce((text: string) => getSuggestionRef.current(text), 400)).current;
    
    const getUserSuggestion = (text: string) => {
        if (text === '') return;
        userSuggestion(text)
    }
    // ************************* End of user suggestion code ************************

    const getUserItem = (u: any) => {
        const userList = suggestionUserList[0]?.suggestions;
        const user = userList?.find((user: any) => user.text.toUpperCase() === u.toUpperCase());
        if (user && user.uId) {
            getUser(user);
        }
    }

    const getUser = (item: any) => {
        setSearchText(item.text);
    }

    const clearForm = () => {
        setSearchText('');
        setCurrentEntityType('');
        setStartDate('');
        setEndDate('');
        setSearchText2('');
        setCurrentProject('');
        setLogData([]);
        setPagination({ pageIndex: 1, pageSize: 10, pageCount: 0, totalCount: 0 });
        // setPageNumber(1);
        // setPageSize(10);
        //clear table also here

    }
    const submit = () => {
        getUserActivityLog();
    }
    
    const getUserActivityLog = (page: number = 1, size: number = 10) => {
        let payload  = {
            pageNumber: page,
            pageSize: size,
            searchText: searchText2,
            entityType: currentEntityType,
            username: searchText,
            startDate: startDate,
            endDate: endDate,
            projectId: currentProject
        }
        dispatch(showLoading());
        HttpService.postRequest(API_USER.GET_USER_ACTIVITY_LOG, payload).then(
            (res: any) => {
                setLogData(res.data);
                setPagination({
                    pageIndex: page,
                    pageSize: size,
                    pageCount: Math.ceil(res.totalCount / size),
                    totalCount: res.totalCount
                });
                dispatch(hideLoading());
            },
            (err: any) => {
                dispatch(hideLoading());
                Toast(err.message, "error")
            },
        )
    }

    // useEffect(() => {
    //     if (pageNumber !== 1 || pageSize !== 10) {
    //         getUserActivityLog();
    //     }
    // }, [pageNumber, pageSize]);

    //pagination methods
     const pageChange = (event: any) => {
        getUserActivityLog(event, pagination.pageSize);
    }

    const onSelect = (event: any) => {
        const newOption = parseInt(event.target.value, 10);
        getUserActivityLog(1, newOption);
    }

    const getTopItem = () => {
        return 1 + pagination.pageSize * (pagination.pageIndex - 1);
    }

    const getProjects = () => {
        HttpService.getRequest(API_URL.GET_PROJECT).then(
        (res: any) => {
            setProjectList(res ? res :	[]);
        }, (err: any) => {
            Toast(err.message, "error");
        })
    }

    const handleCurrentProjectInputChange = (event: any) => {
        const { value } = event.target;
        setCurrentProject(value);
    }

    useEffect(() => {
        getProjects();
    }, []);

  return (
    <div>
         <div className='pt-10 pl-20 pr-20 pb-0'>
            <h4>User Action Log</h4>
        </div>
        <div className='pl-20 pr-20 pb-20'>
            <div className="wk-grid-page-container p-10 card mb-20 pb-0" style={{background: '#F2F8FC'}}>
                <div className="wk-grid" style={{gap: 0}}>
                    <div className="wk-col-3">
                        <SelectField size={'small'} label="Project" labelFor="select-project" indicator="required">
                            <select id="select-project" value={currentProject || ''}
                                onChange={(event: any) => handleCurrentProjectInputChange(event)}>
                                <option value="">-- Select Project --</option>
                                {projectList.map((item: any, i: number) => (
                                    <option value={item.id} key={i}>{item.name}</option>
                                ))}
                            </select>
                        </SelectField>
                    </div>
                     <div className="wk-col-3">
                         <SelectField size={'small'} label="Entity Type" labelFor="select-entity-type" indicator="required">
                            <select id="select-entity-type" value={currentEntityType || ''}
                                onChange={(event: any) => handleInputChange(event)}>
                                <option value="">-- Select Entity Type --</option>
                                {entityTypeList.map((item: any, i: number) => (
                                    <option value={item.code} key={i}>{item.name}</option>
                                ))}
                            </select>
                        </SelectField>
                    </div>                   
                   
                    <div className="wk-col-3">
                        <InputField label="Start Date" size={'small'}>
                            <input
                                type="date"  name="date"
                                value={startDate}
                                onChange={(event: any) => setStartDate(event.target.value)}
                            />
                        </InputField>
                    </div>
                    <div className="wk-col-3 pr-0">
                        <InputField label="End Date" size={'small'}>
                            <input
                                type="date"  name="date"
                                value={endDate}
                                onChange={(event: any) => setEndDate(event.target.value)}
                                min={startDate}
                            />
                        </InputField>
                    </div>
                </div>
                <div className="wk-grid" style={{gap: 0}}>
                    <div className="wk-column-3 relative custom-overflow-inherit" id="user-suggestion">
                        <label htmlFor="search-user-email" className="cg-field-label " style={{fontSize: '14px'}}>User Email</label>
                        <SearchSuggestionsWrapper 
                            ref={searchRef} 
                            onSearchClick={getUserItem} 
                            onInputChange={getUserSuggestion}
                            onItemSelected={getUser} 
                            options={suggestionUserList} 
                            size="small" 
                            isSearchEnabledOnEmptyInput={false}
                            value={searchText} 
                            placeholder="Search by email id">
                        </SearchSuggestionsWrapper >
                    </div>
                    <div className="wk-col-3">
                        <InputField label="Search" size={'small'}>
                            <input
                                type="text"
                                value={searchText2}
                                onChange={(event: any) => setSearchText2(event.target.value)}
                            />
                        </InputField>
                    </div>
                    <div className="wk-col-3 pt-20">
                        <ButtonField size={'small'}>
                            <button type="button" style={{ marginRight: '5px' }} onClick={submit} disabled={currentEntityType === '' || currentProject === ''}>
                                Submit
                            </button>
                        </ButtonField>
                        <ButtonField size={'small'} mode={'ghost'}>
                            <button type="button" style={{ marginRight: '5px' }} onClick={clearForm}>
                                Clear
                            </button>
                        </ButtonField>
                    </div>
                    <div className="wk-col-3"></div>
                </div>
            </div>
            <table className="wk-table wk-table-bordered wk-table-small">
                <thead>
                    <tr>
                        <th>User Email</th>
                        <th>Entity Type</th>
                        <th>Entity Name</th>
                        <th>Action Performed</th>
                        <th>Change</th>
                        <th>Timestamp</th>
                    </tr>
                </thead>
                <tbody>
                    {logData.length > 0 ? logData.map((logItem: any, index: number) => (
                        <tr key={index}>
                        <td>{logItem.username}</td>
                        <td>{logItem.entityType}</td>
                        <td>{logItem.entityName}</td>
                        <td>{logItem.action}</td>
                        <td>
                            <pre>
                                {logItem.diff}
                            </pre>
                        </td>
                        <td>{moment(logItem.actionTime).utc().format('MM-DD-YYYY HH:mm:ss [UTC]')}</td>
                    </tr>
                    )) : (
                        <tr>
                            <td colSpan={6} style={{ textAlign: 'center' }}>No records found</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div className="mt-5">
                {logData.length > 0 ? (
                    <PaginationBar>
                        <PaginationBarLeft>
                            {getTopItem()} - {(pagination.pageSize * pagination.pageIndex) > pagination.totalCount ? pagination.totalCount : (pagination.pageSize * pagination.pageIndex)} of{' '}
                            {pagination.totalCount} results{' '}
                        </PaginationBarLeft>
                        <PaginationBarRight>
                            <SelectField size="small">
                                <select onChange={(event: any) => onSelect(event)} value={pagination.pageSize}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </SelectField>
                            <Pagination
                                pageIndex={pagination.pageIndex}
                                pageCount={pagination.pageCount}
                                controlMode='controlled'
                                onUserRequest={(event: any) => pageChange(event)}></Pagination>
                        </PaginationBarRight>
                    </PaginationBar>
                ) : null}
            </div>
        </div>
    </div>
  );
}
export default UserActivityLog;